// @ts-nocheck
// Agent Portal (/cti2) — "Save Dispose & Next Lead" support. LeadsScreen.tsx's
// own lead-group list (`groups`) is local component state and unmounts the
// moment the agent leaves the dashboard tab for the Live-call tab, which is
// exactly where disposition submit happens — so there's nothing to read off
// a shared store here. This re-fetches fresh: the assignment summary (for the
// disposition form) plus one pending lead of the assignment the just-disposed
// lead came from — never the whole lead list.
import { getApiCall } from '@/service/httpCall';
import { API_AGENT_LEADS_MY_ASSIGNMENTS, API_AGENT_LEADS_MY_ITEMS } from '@/service/url';

const DIAL_INTENT_KEY = 'cti2.nextLeadDialIntent';
const DIAL_INTENT_TTL_MS = 2 * 60 * 1000;

export function saveNextLeadDialIntent({ agentId, assignmentId, excludeItemId }) {
  if (!agentId || !assignmentId) return;
  try {
    window.localStorage.setItem(DIAL_INTENT_KEY, JSON.stringify({
      agent_id: String(agentId),
      assignment_id: String(assignmentId),
      exclude_item_id: excludeItemId ? String(excludeItemId) : null,
      saved_at: Date.now(),
    }));
  } catch (err) { console.error('Failed to store next-lead dial intent', err); }
}

export function clearNextLeadDialIntent() {
  try { window.localStorage.removeItem(DIAL_INTENT_KEY); } catch { /* storage unavailable */ }
}

/** The pending intent for this agent, or null. Reading it also clears it. */
export function takeNextLeadDialIntent(agentId) {
  let raw = null;
  try { raw = window.localStorage.getItem(DIAL_INTENT_KEY); } catch { return null; }
  if (!raw) return null;
  clearNextLeadDialIntent();
  if (!agentId) return null;
  try {
    const intent = JSON.parse(raw);
    if (String(intent?.agent_id) !== String(agentId)) return null;
    if (!intent?.assignment_id) return null;
    if (Date.now() - Number(intent.saved_at || 0) > DIAL_INTENT_TTL_MS) return null;
    return intent;
  } catch { return null; }
}

/**
 * Finds the next pending (not completed, not the one just disposed) lead in
 * the same assignment group. Returns `{ lead, group }` or `null` if there's
 * nothing left to advance to (or the group/endpoint can't be reached).
 */
export async function fetchNextPendingLeadInGroup(assignmentId, excludeItemId) {
  if (!assignmentId) return null;
  try {
    const qs = new URLSearchParams({ status: 'pending', limit: '1' });
    if (excludeItemId) qs.set('exclude_id', String(excludeItemId));
    const [groups, page] = await Promise.all([
      getApiCall(API_AGENT_LEADS_MY_ASSIGNMENTS),
      getApiCall(`${API_AGENT_LEADS_MY_ITEMS.replace(':assignmentId', assignmentId)}?${qs}`),
    ]);
    const group = (Array.isArray(groups) ? groups : []).find(
      (g) => String(g?.assignment_id) === String(assignmentId),
    );
    const lead = page?.rows?.[0];
    return group && lead ? { lead, group } : null;
  } catch (err) {
    console.error('Failed to fetch next pending lead', err);
    return null;
  }
}
